module.exports = __webpack_public_path__ + "static/img/bananok.4b30ad45.webp";